<template>
  <div>
    <TheTopNav />
    <main class="w-full min-h-screen primary-content flex flex-col relative overflow-hidden">
      <div class="w-full m-auto" style="min-height:70vh;z-index: 1;">
        <NuxtPage :transition="false" />
      </div>
      <div class="gradient-bg" style="z-index:0;width:120%;left:-10%;top:0"></div>
      <TheFooter class="mt-auto" />
    </main>

  </div>
</template>

<script setup>

useSchemaOrg([
  // @todo Select Identity: https://unhead-schema-org.harlanzw.com//guide/guides/identity
  defineOrganization({
    name: 'Supapm.com',
    // logo: 'https://ik.imagekit.io/aicosmetic/Image%20Logo%201.svg?updatedAt=1691105907977',
  }),
  defineWebSite({
    name: 'Supa PM - AI powered Product Management',
  }),
  defineWebPage(),
])

</script>